import { render, staticRenderFns } from "./wenet-button.vue?vue&type=template&id=3db92b4e&scoped=true&"
import script from "./wenet-button.vue?vue&type=script&lang=js&"
export * from "./wenet-button.vue?vue&type=script&lang=js&"
import style0 from "./wenet-button.vue?vue&type=style&index=0&id=3db92b4e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3db92b4e",
  null
  
)

export default component.exports